
export let ExitIntentTemplates = {
        MKTEXITINTENTTEMP0 : {
            "heading": {
                "text": "Wait, we have a special offer ",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Enter your email and get 15% off!",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "GET MY 15% OFF NOW",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No, thanks. I'd rather pay a full price",
                "show": true,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP1 : {
            "heading": {
                "text": "<b>GET YOUR E-BOOK</b> FOR FREE",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Enter your email address to download your copy",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "<b>GIVE ME</b> THE BOOK",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No thanks",
                "show": true,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "step2Fields": {
                "enabled": false
            },
            "redirect": {
                "status": false,
                "url": "",
                "isURL": null
            },
            "endpoint": {
                "status": false,
                "url": ""
            }
        },
        MKTEXITINTENTTEMP2 : {
            "heading": {
                "text": "Want To Monetize Bounce Traffic",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "FOR FREE?",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "YES I WANT",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": true,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "step2Fields": {
                "enabled": false
            },
            "redirect": {
                "status": false,
                "url": "",
                "isURL": null
            },
            "endpoint": {
                "status": false,
                "url": ""
            }
        },
        MKTEXITINTENTTEMP3 : {
            "heading": {
                "text": "<b>GET YOUR E-BOOK</b> FOR FREE",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Enter your email address to download your copy",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "<b>GIVE ME</b> THE BOOK",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "<b>DON'T </b>NEED IT",
                "show": true,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "step2Fields": {
                "enabled": false
            },
            "redirect": {
                "status": false,
                "url": "",
                "isURL": null
            },
            "endpoint": {
                "status": false,
                "url": ""
            }
        },
        MKTEXITINTENTTEMP4 : {
            "heading": {
                "text": "<b>SPECIAL OFFER</b> <h3>This Offer is Limited! Grab your Discount!</h3>",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Subscribe and Get 50% discount Now",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "<b>GIVE ME</b><br>THE BOOK",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "<b>DON'T</b><br>NEED IT",
                "show": true,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "step2Fields": {
                "enabled": false
            },
            "redirect": {
                "status": false,
                "url": "",
                "isURL": null
            },
            "endpoint": {
                "status": false,
                "url": ""
            }
        },
        MKTEXITINTENTTEMP5 : {
            "heading": {
                "text": "Subscribe here to get <b>Custom Design T-shirt</b> GET YOUR T-SHIRT THAT YOU",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "REALLY LIKE",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "GET MY T-SHIRT",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No, thanks. I don't need it",
                "show": true,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "step2Fields": {
                "enabled": false
            },
            "redirect": {
                "status": false,
                "url": "",
                "isURL": null
            },
            "endpoint": {
                "status": false,
                "url": ""
            }
        },
        MKTEXITINTENTTEMP6 : {
            "heading": {
                "text": "Want to Generate",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "5000 NEW SALES LEADS FOR FREE?",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "<b>GIVE ME</b> THE BOOK",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "<b>DON'T </b>NEED IT",
                "show": true,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "step2Fields": {
                "enabled": false
            },
            "redirect": {
                "status": false,
                "url": "",
                "isURL": null
            },
            "endpoint": {
                "status": false,
                "url": ""
            }

        },
        MKTEXITINTENTTEMP7 : {
            "heading": {
                "text": "SUBSCRIBE",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "AND GET YOUR FREE COUPONS",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "GET COUPONS",
                "show": true,
                "colorMode": "hex"
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": true,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email'],
                "email": true,
                "phone": false
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP8 : {
            "heading": {
                "text": "SUBSCRIBE",
                "show": false,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "AND GET YOUR FREE COUPONS",
                "show": false,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "GET COUPONS",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/700x370.png",
                "isImage": true
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "step2Fields": {
                "enabled": true,
                "heading": {
                    "text": "Use this Coupon Code : ",
                    "color": "",
                    "colorMode": "hex",
                    "fontsize": "",
                    "show": true
                },
                "subheading": {
                    "fontsize": "",
                    "color": "",
                    "colorMode": "hex",
                    "text": "<b>XYZ2D5</b>",
                    "show": true
                },
                "confirmButton": {
                    "content": {
                        "text": "I'm In",
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": true
                },
                "cancelButton": {
                    "content": {
                        "text": "No, Thanks",
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": true
                },
                "background": {
                    "color": "",
                    "colorMode": "rgba",
                    "show": true
                },
                "logoBanner": {
                    // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/banner.jpg",
                    "isImage": true
                }
            }
        },
        MKTEXITINTENTTEMP9 : {
            "heading": {
                "text": "SUBSCRIBE",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Get Instant Offers. Just enter the email address below, will Email you the code",
                "show": false,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "Get Offer Code",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP10 : {
            "heading": {
                "text": "NewsPill",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Just what the News Doc ordered,<br/> a daily dose of top 10 must-reads in less than 5 minutes.",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "Sign me up",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "step2Fields": {
                "enabled": true,
                "heading": {
                    "text": "Thanks for signup",
                    "color": "",
                    "colorMode": "hex",
                    "fontsize": "",
                    "show": true
                },
                "subheading": {
                    "fontsize": "",
                    "color": "",
                    "colorMode": "hex",
                    "text": "Now you will start receiving a daily dose of top 10 must-reads",
                    "show": true
                },
                "confirmButton": {
                    "content": {
                        "text": "I'm In",
                        "color": "",
                        "colorMode": "hex",
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": false
                },
                "cancelButton": {
                    "content": {
                        "text": "No, Thanks",
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": false
                },
                "background": {
                    "color": "",
                    "colorMode": "rgba",
                    "show": true
                },
                "logoBanner": {
                    // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                    "isImage": true
                }
            }
        },
        MKTEXITINTENTTEMP11 : {
            "heading": {
                "text": "<b>GET YOUR E-BOOK11</b> FOR FREE",
                "show": false,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Enter your email address to download your copy",
                "show": false,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "<b>NOTIFY</b> US",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No thanks",
                "show": true,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/700x375.png",
                "isImage": true
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP12 : {
            "heading": {
                "text": "Wait we have a <b> Special Offer </b>",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Sign up to know our latest news before everybody else.",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "<b>SUBMIT</b>",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No thanks",
                "show": false,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "isImage": true
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP13 : {
            "heading": {
                "text": "Wait we have a <b> Special Offer </b>",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Sign up to know our latest news before everybody else.",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "<b>SUBMIT</b>",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "isImage": true,
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "step2Fields": {
                "enabled": true,
                "heading": {
                    "text": "Thanks for signup",
                    "color": "",
                    "colorMode": "hex",
                    "fontsize": "",
                    "show": true
                },
                "subheading": {
                    "fontsize": "",
                    "color": "",
                    "colorMode": "hex",
                    "text": "Welcome to the world of",
                    "show": true
                },
                "confirmButton": {
                    "content": {
                        "text": "I'm In",
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": false
                },
                "cancelButton": {
                    "content": {
                        "text": "No, Thanks",
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": false
                },
                "background": {
                    "color": "",
                    "colorMode": "rgba",
                    "show": true
                },
                "logoBanner": {
                    // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                    "isImage": true
                }
            }
        },
        MKTEXITINTENTTEMP14 : {
            "heading": {
                "text": "Notification heading goes here",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Insert short description here. Maximum upto 2 lines for better view",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "Get Offer Code",
                "show": true,
                "colorMode": "hex"
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/squared-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": [''],
                "email": false,
                "phone": false
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP15 : {
            "heading": {
                "text": "<b> In a Hurry ? </b>",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "No problem!<br>Simply enter your email<br>address and we will send<br>you your basket",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "<b>SUBMIT</b>",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "Continue Shopping",
                "show": true,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/300x377.png",
                "isImage": true
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": false
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP16 : {
            "heading": {
                "text": "Get Two Vouchers of <b> 50 INR </b>",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "on Your Email Instantly",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "SUBSCRIBE",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No thanks",
                "show": false,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/300x252.png",
                "isImage": true
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": false
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP17 : {
            "heading": {
                "text": "BEFORE YOU GO",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Get access to the secret sales & hand picked stories Delivered weekly.",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "subscribe",
                "show": true,
                "colorMode": "hex"
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "overlayfields": {
                "show": ['email'],
                "email": true,
                "phone": false
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/side-image2.png",
                "isImage": true,
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP18 : {
            "heading": {
                "text": "GET SECRET OFFERS IN YOUR INBOX",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Get Instant Offers. Just enter the email address below, will Email you the code",
                "show": false,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "Submit",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "logoBanner": {
                "url" : "",
                "isImage": true
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": false
            },
            "redirect": {
                "status": false,
                "url": ""
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP19 : {
            "heading": {
                "text": "FLAT <b>15%</b> OFF<br><span>ON ALL MEDICINES</span>",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "<strong>Use Coupon Code : <b>COUPONFORPREVIEW</b></strong>Exclusive Offer Just For You!",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "Submit",
                "show": false,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "background": {
                "color": "#ffffff",
                "colorMode": "hex",
                "show": true
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/330x168.png",
                "isImage": true
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": [],
                "email": false,
                "phone": false
            },
            "redirect": {
                "status": false,
                "url": ""
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP20 : {
            "heading": {
                "text": "Get FLAT 20% OFF on all medicines. We deliver anywhere in India. Use Coupon Code: <b>COUPONFORPREVIEW</b>",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "",
                "show": false,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "Submit",
                "show": false,
                "colorMode": "hex"
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "background": {
                "color": "#09918f",
                "colorMode": "hex",
                "show": true
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/183x223.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": [],
                "email": false,
                "phone": false
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP21 : {
            "heading": {
                "text": "Get FLAT 20% OFF on all medicines. We deliver anywhere in India. Use Coupon Code: <b>COUPONFORPREVIEW</b>",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "",
                "show": false,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "Submit",
                "show": false,
                "colorMode": "hex"
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "background": {
                "color": "#09918f",
                "colorMode": "hex",
                "show": true
            },
            "logoBanner": {
                "url" : "",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": [],
                "email": false,
                "phone": false
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP22 : {
            "heading": {
                "text": "<b> Hold on! </b>",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Sign up to get our latest updates.",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "<b>SUBMIT</b>",
                "show": true,
                "colorMode": "hex"
            },
            "cancelButton": {
                "text": "No thanks",
                "show": false,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "isImage": true
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'name'],
                "email": true,
                "name": true
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP23 : {
            "heading": {
                "text": "Don't miss out",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "EXCLUSIVES, OFFERS, AND THE LATEST FOR YOU",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "<b>Sign Up</b>",
                "show": true,
                "colorMode": "hex"
            },
            "cancelButton": {
                "text": "No Thanks",
                "show": false,
                "colorMode": "hex"
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "logoBanner": {
                "show" : true,
                // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                "isImage": false,
                "isLogoAndImage": true
            },
            "overlayfields": {
                "show": ['email'],
                "email": true
            },
            "step2Fields": {
                "enabled": true,
                "heading": {
                    "text": "Thank You",
                    "color": "",
                    "colorMode": "hex",
                    "fontsize": "",
                    "show": true
                },
                "subheading": {
                    "fontsize": "",
                    "color": "",
                    "colorMode": "hex",
                    "text": "Successfully Subscribed to Newsletter",
                    "show": true
                },
                "confirmButton": {
                    "content": {
                        "text": "",
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": false
                },
                "cancelButton": {
                    "content": {
                        "text": "No, Thanks",
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": false
                },
                "background": {
                    "color": "",
                    "colorMode": "rgba",
                    "show": true
                },
                "logo": {
                    "show": true,
                    // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/checkmark.gif",
                    "position": "center"
                },
                "logoBanner": {
                    "show" : true,
                    // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                    "isImage": true
                }
            }
        },
        MKTEXITINTENTTEMP24 : {
            "heading": {
                "text": "Don't miss out",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "EXCLUSIVES, OFFERS, AND THE LATEST FOR YOU",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "Submit",
                "show": true,
                "colorMode": "hex"
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL + "assets/img/your-logo.png",
                "isImage": true
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email', 'phone'],
                "email": true,
                "phone": true
            },
            "redirect": {
                "status": false,
                "url": ""
            },
            "step2Fields": {
                "enabled": true,
                "heading": {
                    "text": "Thank You",
                    "color": "",
                    "colorMode": "hex",
                    "fontsize": "",
                    "show": true
                },
                "subheading": {
                    "fontsize": "",
                    "color": "",
                    "colorMode": "hex",
                    "text": "Successfully Subscribed to Newsletter",
                    "show": true
                },
                "confirmButton": {
                    "content": {
                        "text": "",
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": false
                },
                "cancelButton": {
                    "content": {
                        "text": "No, Thanks",
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": false
                },
                "background": {
                    "color": "",
                    "colorMode": "rgba",
                    "show": true
                },
                "logo": {
                    "show": true,
                    // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/checkmark.gif",
                    "position": "center"
                },
                "logoBanner": {
                    "show" : true,
                    // "url" : mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                    "isImage": true
                }
            }
        },
        MKTEXITINTENTTEMP25 : {
            "heading": {
                "text": "Subscribe for stellar fashion content, new collection & exciting offers",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Get Instant Offers. Just enter the email address below, will Email you the code",
                "show": false,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "SIGN UP",
                "show": true,
                "colorMode": "hex"
            },
            "logoBanner": {
                "url" : "",
                "isImage": true
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['email'],
                "email": true,
                "phone": false
            },
            "redirect": {
                "status": false,
                "url": ""
            },
            "cancelButton": {
                "text": "No thanks",
                "show": false,
                "colorMode": "hex"
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP26 : {
            "heading": {
                "text": "Get FLAT 20% OFF on all medicines. We deliver anywhere in India. Use Coupon Code: <b>COUPONFORPREVIEW</b>",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "",
                "show": false,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "Submit",
                "show": false,
                "colorMode": "hex"
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "background": {
                "color": "#09918f",
                "colorMode": "hex",
                "show": true
            },
            "logoBanner": {
                "url" : "",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": [],
                "email": false,
                "phone": false
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP27 : {
            "heading": {
                "text": "Want To Monetize Bounce Traffic",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "FOR FREE?",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "YES I WANT",
                "show": true,
                "colorMode": "hex"
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": true,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/img/your-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": ['name', 'email'],
                "name": true,
                "email": true
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP28 : {
            "heading": {
                "text": "Notification heading goes here",
                "show": false,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Insert short description here. Maximum upto 2 lines for better view",
                "show": false,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "Get Offer Code",
                "show": false,
                "colorMode": "hex"
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL+"assets/ng/partials/onsitepush/templatesimg/mktng.gif",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/ng/partials/onsitepush/templatesimg/mktng.gif",
                "position": "center"
            },
            "overlayfields": {
                "show": [''],
                "email": false,
                "phone": false
            },
            "step2Fields": {
                "enabled": false
            },
            "redirect": {
                "status": false,
                "url": ""
            }


        },
        MKTEXITINTENTTEMP29 : {
            "heading": {
                "text": "UNLOCK",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "<h2>10% OFF</h2> Your Order",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "CONTINUE",
                "show": true,
                "colorMode": "hex",
                "background": {
                    "color": "",
                    "colorMode": "rgba"
                }
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL + "assets/img/your-logo.png",
                "isImage": true
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/29-preview.png",
            },
            "overlayfields": {
                "show": ['email'],
                "email": true,
                "phone": false
            },
            "redirect": {
                "status": false,
                "url": ""
            },
            "step2Fields": {
                "enabled": true,
                "heading": {
                    "text": "UNLOCK",
                    "color": "",
                    "colorMode": "hex",
                    "fontsize": "",
                    "show": true
                },
                "subheading": {
                    "fontsize": "",
                    "color": "",
                    "colorMode": "hex",
                    "text": "<h2>10% OFF</h2> Your Order",
                    "show": true
                },
                "confirmButton": {
                    "content": {
                        "text": "<h2>GET 10% OFF NOW</h2>",
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": true
                },
                "consentMsg": {
                    "text": "By signing up,you agree to recieve recurring automated marketing text.",
                    "show": true,
                    "status": false,
                    "color": "#ffffff",
                    "colorMode": "hex",
                    "fontsize": ""
                },
                "cancelButton": {
                    "content": {
                        "text": "No, Thanks",
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": false
                },
                "background": {
                    "color": "",
                    "colorMode": "rgba",
                    "show": true
                },/*
                "logo": {
                    "show": true,
                    // "url" : mktConfig.absoluteURL + "assets/img/your-logo.png",
                    "position": "center"
                },*/
                "logoBanner": {
                    "show" : true,
                    // "url" : mktConfig.absoluteURL + "assets/img/your-logo.png",
                    "isImage": true
                }
            }
        },
        MKTEXITINTENTTEMP30 : {
            "heading": {
                "text": "UNLOCK",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "<h2>10% OFF</h2> Your Order",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "CONNECT",
                "show": true,
                "colorMode": "hex",
                "background": {
                    "color": "",
                    "colorMode": "rgba"
                }
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show": true,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": ""
            },
            "cancelButton": {
                "text": "No, thanks",
                "show": false,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url" : mktConfig.absoluteURL + "assets/img/your-logo.png",
                "isImage": true
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/29-preview.png",
            },
            "overlayfields": {
                "show": ['email'],
                "email": true,
                "phone": false
            },
            "redirect": {
                "status": false,
                "url": ""
            },
            "step2Fields": {
                "enabled": false
            }
        },
        MKTEXITINTENTTEMP31 : {
            "heading": {
              text: "Spin and Win",
              show: true,
              colorMode: "hex",
              color: "#ffffff",
              fontsize: "25"
            },
            background: {
                color: '#203657',
                colorMode: 'hex'
            },
            step2Fields: {
                enabled: true,
                "heading": {
                    "text": "Get a chance to win an exclusive discount coupon.",
                    "show": true,
                    "colorMode": "hex",
                    "color": "#ffffff",
                    "fontsize": '35'
                },
                "subheading": {
                    "text": "Enter your full name, mobile number and email id to spin the wheel for a chance to win an exclusive discount coupon ",
                    "show": true,
                    "colorMode": "hex",
                    "color": "#fff",
                    "fontsize": '16'
                },
                "confirmButton": {
                    "text": "<b>Spin the Wheel</b>",
                    "show": true,
                    content: {
                        color: '#fff',
                        colorMode: 'hex'
                    },
                    background: {
                        color: '#FFFFFF',
                        colorMode: 'hex'
                    }
                },
                "consentMsg": {
                    "text": "I agree to my personal data being stored and used for further communication",
                    "show": true,
                    "status": true,
                    "color": "#ffffff",
                    "colorMode": "hex",
                    "fontsize": ""
                },
                "cancelButton": {
                    "text": "No, thanks",
                    "show": false,
                    "colorMode": "hex"
                },
                "overlayfields": {
                    "show": ['name','email','phone'],
                    "email": true,
                    "phone": true,
                    'name': true
                },
                "fortuneWheel" : {
                    "show" : true,
                    "colorMode": "hex",
                    "emailConfig": {
                        "templateUuid": "",
                        "sendEmail": false
                    },
                    "fortuneWheelData" : [
                        {'label' : 'Label 1',  'color' : '#c23535',  'coupon' : '', isDynamicCoupon: false, coupon_data: '', 'colorMode' : 'hex', 'fontSize': 14, textColor: "#ffffff"},
                        {'label' : 'Label 2',  'color' : '#ccaeae',  'coupon' : '', isDynamicCoupon: false, coupon_data: '', 'colorMode' : 'hex', 'fontSize': 14, textColor: "#ffffff"},
                        {'label' : 'Label 3',  'color' : '#a54f65',  'coupon' : '', isDynamicCoupon: false, coupon_data: '','colorMode' : 'hex', 'fontSize': 14, textColor: "#ffffff"}
                    ]
                },
                claimBar: {
                    enabled: true,
                    content: {
                        text: '70% offers have been claimed, spin the wheel to claim yours.',
                        color: "#fff",
                        colorMode: "hex"
                    },
                    percent: {
                        value: "70",
                        color: "#6E2C34",
                        colorMode: "hex"
                    }
                },
                background: {
                    color: '#203657',
                    colorMode: 'hex'
                },
            },
            "step3Fields": {
                "enabled": true,
                heading: {
                    "text": "Congratulations! you have won.",
                    "color": "",
                    "colorMode": "hex",
                    "fontsize": "",
                    "show": true
                },
                subheading: {
                    "fontsize": "",
                    "color": "",
                    "colorMode": "hex",
                    "text": "Validity of offer or caption goes here ",
                    "show": true
                },
                "confirmButton": {
                    "text": "Copy & Continue",
                    "content": {
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": true
                },

            }
        },
        MKTEXITINTENTTEMP32 : {
            "heading": {
                text: "Spin and Win",
                show: true,
                colorMode: "hex",
                color: "#ffffff",
                fontsize: "25"
            },
            background: {
                color: '#203657',
                colorMode: 'hex'
            },
            step2Fields: {
                enabled: true,
                "heading": {
                    "text": "Get a chance to win an exclusive discount coupon.",
                    "show": true,
                    "colorMode": "hex",
                    "color": "#ffffff",
                    "fontsize": '35'
                },
                "subheading": {
                    "text": "Enter your full name, mobile number and email id to spin the wheel for a chance to win an exclusive discount coupon ",
                    "show": true,
                    "colorMode": "hex",
                    "color": "#fff",
                    "fontsize": '16'
                },
                "confirmButton": {
                    "text": "<b>Spin the Wheel</b>",
                    "show": true,
                    content: {
                        color: '#fff',
                        colorMode: 'hex'
                    },
                    background: {
                        color: '#FFFFFF',
                        colorMode: 'hex'
                    }
                },
                "consentMsg": {
                    "text": "I agree to my personal data being stored and used for further communication",
                    "show": true,
                    "status": true,
                    "color": "#ffffff",
                    "colorMode": "hex",
                    "fontsize": ""
                },
                "cancelButton": {
                    "text": "No, thanks",
                    "show": false,
                    "colorMode": "hex"
                },
                "overlayfields": {
                    "show": ['name','email','phone'],
                    "email": true,
                    "phone": true,
                    'name': true
                },
                "fortuneWheel" : {
                    "show" : true,
                    "colorMode": "hex",
                    "emailConfig": {
                        "templateUuid": "",
                        "sendEmail": false
                    },
                    "fortuneWheelData" : [
                        {'label' : 'Label 1',  'color' : '#c23535',  'coupon' : '', isDynamicCoupon: false, coupon_data: '', 'colorMode' : 'hex', 'fontSize': 12, textColor: "#ffffff"},
                        {'label' : 'Label 2',  'color' : '#ccaeae',  'coupon' : '', isDynamicCoupon: false, coupon_data: '', 'colorMode' : 'hex', 'fontSize': 12, textColor: "#ffffff"},
                        {'label' : 'Label 3',  'color' : '#a54f65',  'coupon' : '', isDynamicCoupon: false, coupon_data: '','colorMode' : 'hex', 'fontSize': 12, textColor: "#ffffff"}
                    ]
                },
                claimBar: {
                    enabled: true,
                    content: {
                        text: '70% offers have been claimed, spin the wheel to claim yours.',
                        color: "#fff",
                        colorMode: "hex"
                    },
                    percent: {
                        value: "70",
                        color: "#6E2C34",
                        colorMode: "hex"
                    }
                },
                background: {
                    color: '#203657',
                    colorMode: 'hex'
                },
            },
            "step3Fields": {
                "enabled": true,
                heading: {
                    "text": "Congratulations! you have won.",
                    "color": "",
                    "colorMode": "hex",
                    "fontsize": "",
                    "show": true
                },
                subheading: {
                    "fontsize": "",
                    "color": "",
                    "colorMode": "hex",
                    "text": "Validity of offer or caption goes here ",
                    "show": true
                },
                "confirmButton": {
                    "text": "Copy & Continue",
                    "content": {
                        "color": "",
                        "colorMode": "hex"
                    },
                    "background": {
                        "color": "",
                        "colorMode": "rgba"
                    },
                    "show": true
                },

            }
        },


        MKTEXITINTENTCUSTOMTEMP : {
            "heading": {
                "text": "Custom Template",
                "show": true,
                "colorMode": "hex"
            },
            "subheading": {
                "text": "Create Your Own Custom Template",
                "show": true,
                "colorMode": "hex"
            },
            "confirmButton": {
                "text": "",
                "show": false,
                "colorMode": "hex"
            },
            "cancelButton": {
                "text": "",
                "show": false,
                "colorMode": "hex"
            },
            "logoBanner": {
                // "url": mktConfig.absoluteURL + "assets/img/your-logo.png",
                "isImage": false
            },
            "image": {
                "show": true,
                // "url": mktConfig.absoluteURL+"assets/img/exitintent-template/side-image.png",
                "position": "center"
            },
            "overlayfields": {
                "show": [''],
                "email": false,
                "phone": false
            },

            "step2Fields": {
                "enabled": false
            }
        }
    };

